export const CANVAS_VIEWPORT_ID = 'canvas-viewport';
